module.exports = __webpack_public_path__ + "img/title2-en.1af798c3.png";